import { ArrowRight, BookOpen, Check, ClipboardList, Plus, RefreshCw, Send } from "lucide-react";
import { cn } from "@/lib/utils";

type PracticeCardProps = {
	id: string;
	title: string;
	subtitle: string;
	active: boolean;
	canShare: boolean;
	hasAssessment: boolean;
	onOpen: (id: string) => void;
	onToggle: (id: string) => void;
};

export function PracticeCard({
	id,
	title,
	subtitle,
	active,
	canShare,
	hasAssessment,
	onOpen,
	onToggle,
}: PracticeCardProps) {
	return (
		<article className="practice-card practice-bank-card">
			<button className="practice-card-link" onClick={() => onOpen(id)} type="button">
				<span className="practice-book-icon">
					<BookOpen size={26} />
				</span>
				<span className="practice-card-body">
					<strong>{title}</strong>
					<small>{subtitle}</small>
				</span>
				<ArrowRight size={17} />
			</button>
			<div className="practice-card-tags">
				{active && (
					<span className="practice-status">
						<RefreshCw size={12} />
						持续练习中
					</span>
				)}
				<span>
					<BookOpen size={12} />
					行动练习
				</span>
				{hasAssessment && (
					<span>
						<ClipboardList size={12} />
						含自评
					</span>
				)}
				{canShare && (
					<span>
						<Send size={12} />
						可分享
					</span>
				)}
			</div>
			<button className="practice-start" onClick={() => onOpen(id)} type="button">
				{active ? "今天练一次" : "开始练习"}
				<ArrowRight size={15} />
			</button>
			<button
				aria-label={active ? "移出持续练习" : "加入持续练习"}
				aria-pressed={active}
				className={cn("ongoing-toggle", active && "active")}
				onClick={() => onToggle(id)}
				type="button"
			>
				{active ? <Check size={17} /> : <Plus size={17} />}
			</button>
		</article>
	);
}
